module.exports = __webpack_public_path__ + "static/media/logo_default.29eb0ca6.png";